module.exports = __webpack_public_path__ + "img/clock-orange.74f808a9.svg";